<template>
  <VDropdown
    :placement="placement"
    @apply-show="isFocusLoopActive = true"
    @apply-hide="isFocusLoopActive = false"
    popover-inner-class=""
  >
    <FormInput
      v-model="groupLabel"
      type="text"
      readonly
      :placeholder="placeholder"
      :is-required="isRequired"
      :errors="errors"
      :is-error="isError"
    >
      <template #label>
        <slot name="label" />
      </template>
    </FormInput>
    <template #popper>
      <div
        class="tw-w-[250px] tw-overflow-hidden sm:tw-w-[300px] md:tw-w-[400px] lg:tw-w-[600px]"
      >
        <FocusLoop
          :is-active="isFocusLoopActive"
          :auto-focus="false"
          is-arrows-navigation-active
        >
          <FormSelectWithGroups
            :model-value="modelValue"
            @update:model-value="emitUpdatedValue"
            :groups="groups"
            hide-tags
          />
        </FocusLoop>
      </div>
    </template>
  </VDropdown>
</template>

<script setup>
import { computed, ref } from 'vue'
import FormSelectWithGroups from '@/shared/components/forms/FormSelectWithGroups.vue'
import FocusLoop from '@/shared/components/FocusLoop.vue'
import FormInput from '@/shared/components/forms/FormInput.vue'

const props = defineProps({
  placement: {
    type: String,
    default: 'bottom-start',
  },
  groups: {
    type: Array,
    required: true,
  },
  modelValue: {
    type: [Number, String],
    default: '',
  },
  isError: {
    type: Boolean,
    default: false,
  },
  errors: {
    type: [Array, String],
    default: '',
  },
  placeholder: {
    type: String,
    default: '',
  },
  isRequired: {
    type: Boolean,
    default: false,
  },
})

const emits = defineEmits(['update:modelValue'])

const isFocusLoopActive = ref(false)

const groupLabel = computed(() => {
  return props.groups.reduce((foundLabel, currentGroup) => {
    const foundOption = currentGroup.options.find(
      (option) => option.value === props.modelValue,
    )
    if (foundOption) {
      return foundOption.label
    }
    return foundLabel
  }, '')
})

const emitUpdatedValue = (value) => {
  emits('update:modelValue', value)
}
</script>
